import { render, staticRenderFns } from "./teachertInfo.vue?vue&type=template&id=68f17f92&"
import script from "./teachertInfo.vue?vue&type=script&lang=js&"
export * from "./teachertInfo.vue?vue&type=script&lang=js&"
import style0 from "./teachertInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports